import { CommonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const GetTimesOrganizationData = (orgUnitIdArray, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const map = orgUnitIdArray.map(x => { return { orgUnitId: x }; });
    const stringOrgUnitIds = JSON.stringify(map);

    const orgUnitIdsForUrl = stringOrgUnitIds ? encodeURIComponent(stringOrgUnitIds) : 'NaN';
    const url = `/OrgUnit/Athletes/Flat?orgUnits=${orgUnitIdsForUrl}`;
    CommonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData: {athleteRoster: arrayData},
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

export default GetTimesOrganizationData;